// Importujemy store z autoryzacją (pinia/vuex) – tu są m.in. tokeny użytkownika
import { useAuthStore } from "@/stores/auth.store";

// Główny wrapper do komunikacji z backendem
export const fetchWrapper = {
  // Standardowy GET
  get: request("GET"),
  // GET z dodatkową obsługą licznika (X-Total-Count w nagłówku)
  getWithCount: request("GET", "countIncluded"),
  // POST z JSON-em
  post: request("POST"),
  // PUT z JSON-em
  put: request("PUT"),
  // DELETE
  delete: request("DELETE"),
  // GET, który spodziewa się odpowiedzi w postaci BLOB-a (np. plik do pobrania)
  getBlob: request("GET", "blob"),
};

// Funkcja pomocnicza – zwraca funkcję realizującą żądanie HTTP danego typu
// function request(method, type) {
//   // url endpoint, body – dane, externalToken – opcjonalny token (np. dla zewnętrznej autoryzacji)
//   return (url, body, externalToken = null) => {
//     const { clearErrorMessage } = useAuthStore();
//     clearErrorMessage(); // Czyścimy stare błędy przed każdym żądaniem

//     // Budujemy opcje requestu
//     const requestOptions = {
//       method,
//       headers: authHeader(url, externalToken),
//     };

//     // Obsługa żądania, które spodziewa się BLOB-a (np. pobranie pliku)
//     if (type === "blob") {
//       if (body) {
//         requestOptions.headers["Content-Type"] = "application/json";
//         requestOptions.body = JSON.stringify(body);
//       }
//       return fetch(url, requestOptions).then(handleResponseBlob);
//     }
//     // Dla wszystkich innych, jeśli jest body (np. POST, PUT), serializujemy do JSON
//     if (body) {
//       requestOptions.headers["Content-Type"] = "application/json";
//       requestOptions.body = JSON.stringify(body);
//     }
//     // Wywołujemy fetch i obsługujemy odpowiedź w zależności od typu
//     return fetch(url, requestOptions).then((data) =>
//       handleResponse(data, type)
//     );
//   };
// }

function request(method, type) {
  const isFormData = (v) => typeof FormData !== 'undefined' && v instanceof FormData;

  return (url, body, externalToken = null) => {
    const { clearErrorMessage } = useAuthStore();
    clearErrorMessage();

    const requestOptions = {
      method,
      headers: authHeader(url, externalToken), // Authorization, itp.
    };

    // <-- DODAJ TO
    if (body instanceof FormData) {
      // NIE ustawiaj Content-Type - przeglądarka sama doda boundary
      requestOptions.body = body;
      return fetch(url, requestOptions).then((res) => handleResponse(res, type));
    }

    // tryb BLOB (np. pobieranie pliku)
    if (type === "blob") {
      if (body) {
        if (isFormData(body)) {
          // NIE ustawiaj Content-Type przy FormData
          requestOptions.body = body;
        } else {
          requestOptions.headers["Content-Type"] = "application/json";
          requestOptions.body = JSON.stringify(body);
        }
      }
      return fetch(url, requestOptions).then(handleResponseBlob);
    }

    // pozostałe przypadki
    if (body) {
      if (isFormData(body)) {
        // NIE ustawiaj Content-Type – przeglądarka doda boundary sama
        requestOptions.body = body;
      } else {
        requestOptions.headers["Content-Type"] = "application/json";
        requestOptions.body = JSON.stringify(body);
      }
    }

    return fetch(url, requestOptions).then((data) => handleResponse(data, type));
  };
}


// Generuje nagłówki autoryzacji. Zwraca Authorization: Bearer ... jeśli jesteśmy zalogowani
function authHeader(url, externalToken = null) {
  const { token } = useAuthStore();
  const isLoggedIn = !!token;
  // Sprawdzamy, czy URL należy do naszego API (nie dokładamy tokena do zewnętrznych zapytań)
  const isApiUrl = url.startsWith(process.env.VUE_APP_API_URL);

  // Jeżeli podano token zewnętrzny – zawsze go użyj
  if (externalToken) {
    return { Authorization: `Bearer ${externalToken}` };
  }

  // Jeśli jesteśmy zalogowani i uderzamy do naszego API – dokładaj token
  if (isLoggedIn && isApiUrl) {
    return { Authorization: `Bearer ${token}` };
  } else {
    return {};
  }
}

// Obsługa odpowiedzi z backendu (dla JSON i countIncluded)
async function handleResponse(response, type) {
  // Sprawdzamy, czy odpowiedź jest JSON-em (application/json)
  const isJson = response.headers
    ?.get("content-type")
    ?.includes("application/json");
  const totalCount = response.headers?.get("X-Total-Count");
  let data = isJson ? await response.json() : null;

  // Jeśli odpowiedź miała zwrócić count + dane (np. do paginacji)
  if (data && totalCount && type === "countIncluded") {
    const res = {
      totalCount: totalCount,
      content: data,
    };
    data = res;
  }

  // Obsługa błędów HTTP
  if (!response.ok) {
    const { token, logout, ping } = useAuthStore();
    // Jeśli 401 (brak autoryzacji) – wyloguj i pinguj backend (możesz tu dodać refresh tokena)
    if ([401].includes(response.status) && token) {
      ping(true);
      logout();
    } 
    // 403 – brak uprawnień (nie wylogowuje, tylko loguje błąd)
    else if ([403].includes(response.status) && token) {
      // console.log("add error support");
    }
    // Jeśli backend zwraca szczegółowe info o błędzie, przekazujemy je dalej do obsługi
    const error =
      (data && data[0] && data[0].path + ": " + data[0].userMessage) ||
      response.status;
    return Promise.reject(error); // Promise.reject wymusza obsługę błędu w then/catch
  }

  // Sukces – zwracamy przetworzone dane
  return data;
}

// Obsługa odpowiedzi typu BLOB (np. pobieranie plików)
async function handleResponseBlob(response) {
  const data = await response.blob();
  if (!response.ok) {
    const { token, logout, ping } = useAuthStore();
    if ([401].includes(response.status) && token) {
      ping(true);
      logout();
    } else if ([403].includes(response.status) && token) {
      // console.log("add error support");
    }
    // Tu nie mamy userMessage w blobie, więc przekazujemy tylko status
    const error = (data && data[0] && data[0].userMessage) || response.status;
    return Promise.reject(error);
  }
  return data;
}

export { authHeader };
